import { create } from 'zustand';

import {
  GetPromocionesProps,
  getPromociones,
} from '@/shared/actions/erp/promociones.actions';
import { IPromocionDataPagingResponse } from '@/shared/interfaces/erp/promociones';

interface PromocionesState {
  isLoading: boolean;
  promocionesPaging: IPromocionDataPagingResponse;

  getPromociones: (params?: GetPromocionesProps) => Promise<void>;
  setIsLoading: (isLoading: boolean) => void;
}

export const userPromocionesStore = create<PromocionesState>(set => ({
  promocionesPaging: {
    count: 0,
    next: null,
    previous: null,
    numero_paginas: 0,
    data: [],
  },
  isLoading: false,

  getPromociones: async params => {
    set({ isLoading: true });

    const data = await getPromociones(params);
    const avaiblePromotions = data.data.data.filter(
      promocion => promocion.estado !== false
    );
    data.data.data = avaiblePromotions;

    set({ promocionesPaging: data.data, isLoading: false });
  },
  setIsLoading: isLoading => set({ isLoading }),
}));
